﻿
window.setUpValuesBrowser = function () {

	var activePop = null;

	// popups
	var popProspering = document.querySelector('.values-browser__popover--prospering');
	var popPride = document.querySelector('.values-browser__popover--pride');
	var popPerformance = document.querySelector('.values-browser__popover--performance');
	var popPeople = document.querySelector('.values-browser__popover--people');

	var mobileSVG = document.querySelector('.values-browser__mobile-img');
	var desktopSVG = document.querySelector('.values-browser__desktop-img');
	if (!mobileSVG || !desktopSVG) {
		//GW: prevent init on pages without this feature
		return;
    }
	var popupContainer = document.querySelector('.values-browser__popovers');

	// mobile click areas
	var clickMobilePeople = mobileSVG.querySelector('#People');
	var clickMobilePride = mobileSVG.querySelector('#Pride');
	var clickMobileProspering = mobileSVG.querySelector('#Prospering');
	var clickMobilePerformance = mobileSVG.querySelector('#Performance');

	// desktop click areas
	var clickDeskPeople = desktopSVG.querySelector('#People');
	var clickDeskPride = desktopSVG.querySelector('#Pride');
	var clickDeskProspering = desktopSVG.querySelector('#Prospering');
	var clickDeskPerformance = desktopSVG.querySelector('#Performance');

	// close buttons
	var closeButtons = document.querySelectorAll('.close-popover');

	// click events...
	// mobile svg
	clickMobilePeople.addEventListener('click', function () {
		showPop(popPeople);
	})
	clickMobilePride.addEventListener('click', function () {
		showPop(popPride);
	})
	clickMobileProspering.addEventListener('click', function () {
		showPop(popProspering);
	})
	clickMobilePerformance.addEventListener('click', function () {
		showPop(popPerformance);
	})
	// desktop svg
	clickDeskPeople.addEventListener('click', function () {
		showPop(popPeople);
	})
	clickDeskPride.addEventListener('click', function () {
		showPop(popPride);
	})
	clickDeskProspering.addEventListener('click', function () {
		showPop(popProspering);
	})
	clickDeskPerformance.addEventListener('click', function () {
		showPop(popPerformance);
	})

	// close button click events
	closeButtons.forEach(function (btn) {
		btn.addEventListener('click', function () {
			hidePop();
		})
	});

	function showPop(el) {
		activePop = el;
		activePop.classList.add('show');
		popupContainer.classList.add('show');

		// scroll only on small screens
		if (window.innerWidth < 800) {
			el.scrollIntoView();
		}
    }

	function hidePop() {
		if (activePop != null) {
			activePop.classList.remove('show');
			popupContainer.classList.remove('show');
			activePop = null;
		}
	}
}

if (document.readyState !== 'loading') {
	window.setUpValuesBrowser();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.setUpValuesBrowser();
	});
}